// import { AppConfigAction, CONFIG_LOAD_ERROR, CONFIG_LOADED } from "./actions";
// import { AppConfig } from "./store";
//
// const defaultState: AppConfig = {};
//
// /**
//  * The app config is pulled from the server and stored in the redux store, made available
//  * to the rest of the app as needed.
//  *
//  * @param state
//  * @param action
//  */
// const appConfig = (state = defaultState, action: AppConfigAction) => {
//     switch (action.type) {
//         // if there was an error, put it in the config state, but otherwise leave the state alone
//         case CONFIG_LOAD_ERROR:
//             return {
//                 ...state,
//                 error: action.payload
//             };
//         // accept the loaded config and put it in the app state
//         case CONFIG_LOADED:
//             return {
//                 ...state,
//                 error: null,
//                 ...action.payload,
//                 loadedAt: new Date()
//             };
//         default:
//             return state;
//     }
// };
//
// export default appConfig;
import * as actions from './actions';

export type State = {};

export default (state: State = {}, action: any): State => {
    switch (action.type) {
        case actions.LOAD_CONFIG:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
